export const FileChangeTypeKind = {
    Created: 1,
    Changed: 2,
    Deleted: 3,
};
//# sourceMappingURL=index.js.map